var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-list',{attrs:{"data-list":_vm.outlets},scopedSlots:_vm._u([{key:"listItem",fn:function({ listItem }){return [_vm._v(" "+_vm._s(listItem.name)+" ")]}},{key:"default",fn:function({ form: item }){return [_c('form-outlet',{attrs:{"toCopy":item.item,"operation":item.operation}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }